module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "div_autre",
    attrs: {
      "epub:type": "preamble"
    }
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-001"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XV",
      "title": "XV"
    }
  }, [_c('h1', {
    staticClass: "pre_tit",
    attrs: {
      "epub:type": "title"
    }
  }, [_c('span', [_c('img', {
    staticClass: "imagelarge_intext",
    attrs: {
      "alt": "",
      "id": "fig-pre1",
      "src": "images/fig-pre1.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This book provides a nontechnical overview of what is commonly referred to as the petroleum industry, focusing on oil and natural gas, as well as their derivative products. My goal has been to create an engaging and accessible introduction to this critically important global industry to help those without a technical background who are either new to the industry or simply interested in how it operates.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This book guides the reader through the series of typical decisions made, actions taken, and equipment and processes used to bring petroleum products and natural gas to world markets. I have tried to present information about these various activities in broad but also clear and accurate terms. However, I have not attempted to describe every operational facet or technical aspect; this level of detail is available from a variety of other sources, a number of which are listed in appendix B.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The word “petroleum” is based on the Latin"), _c('i', [_vm._v(" petrus")]), _vm._v(" (rock) and"), _c('i', [_vm._v(" oleum")]), _vm._v(" (oil). Petroleum can range in color from nearly colorless to jet-black. It can be thinner than water or thicker than molasses, and its density can vary from that of a light gas to that of a heavy asphalt. For the purposes of this book, the term"), _c('i', [_vm._v(" petroleum")]), _vm._v(" is used to collectively describe oil and natural gas, whereas the"), _c('i', [_vm._v(" petroleum industry")]), _vm._v(" includes the various entities that perform the range of activities noted in the bulleted list below, as well as those that support those activities.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap1#chap-001"
    }
  }, [_vm._v("Chapter 1")]), _vm._v(" describes the geologic processes and structures related to the formation of both crude oil and natural gas within the earth, as well as its movement (migration) that results in the creation of commercially exploitable accumulations. Chapters "), _c('a', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap2#chap-002"
    }
  }, [_vm._v("2")]), _vm._v(" and "), _c('span', {
    staticClass: "renv",
    attrs: {
      "href": "#/chap3#chap-003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")]), _vm._v(" then focus individually on oil and gas, respectively, providing basic information about their composition, the location of major oil and gas resources around the world, the range of products created from oil and gas, and current patterns of, as well as future projections for, production and use.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_XVI",
      "title": "XVI"
    }
  }, [_vm._v("Chapters 4 through 12 address petroleum industry operations:")])]), _vm._v(" "), _c('ul', {
    staticClass: "liste_puce"
  }, [_c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_vm._v("Searching for and evaluating petroleum resources")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_vm._v("Drilling and completing wells to tap promising formations (onshore and offshore)")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_vm._v("Managing oil and gas production")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_vm._v("Transporting oil")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_vm._v("Transporting natural gas in both gaseous form (by pipeline) and in liquefied form")])]), _vm._v(" "), _c('li', [_c('p', {
    staticClass: "liste_txt_courant"
  }, [_vm._v("Converting oil and gas into various products")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Chapters 13 through 15 address several business-related issues: the structure of the industry, the dynamics of petroleum trading, and the challenges facing the industry. Finally, three appendices provide a listing of terms, abbreviations, and acronyms used in the book; suggested further reading; and organizations that can provide further information on many of the topics covered in this book.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("I hope this book helps the reader understand the petroleum industry and makes clear the ingenuity and skill of its millions of professionals worldwide.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30d0e461","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre2.vue
// module id = 69
// module chunks = 0